import styled from '@emotion/styled';

const StyledUserName = styled('h4')({
  fontWeight: 400,
});

export default StyledUserName;
